import {useQuery, UseQueryResult} from '@tanstack/react-query'
import {fetchResponse} from './utils'

export const useUserData = (): UseQueryResult<User> => {
  return useQuery(['getCurrentUser'], async () => {
    return fetchResponse('/users/info')
  })
}
interface User {
  id: number
  firstName: string
  lastName: string
  email: string
  fullName: string
  version: number
  last4: string
}
